/**
 * Mix custom class with properties and methods to another component
 * @param {Function[]} baseCtors - array of classes mixing target class
 * @returns {(derivedCtor: Function) => void} - target class in which we add attributes and methods
 * @constructor
 */
export function Mixin(baseCtors: Function[]) {
    return function (derivedCtor: Function) {
        baseCtors.forEach(baseCtor => {
            Object.getOwnPropertyNames(baseCtor.prototype).forEach(name => {
                derivedCtor.prototype[name] = baseCtor.prototype[name];
            });
        });
    };
}



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./node_modules/angular-router-loader/src?loader=system&genDir=compiled&aot=false!./src/app/utils/mixins/Mixin.ts